module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.slides) ? _c('div', {
    class: _vm.small ? 'smalltop' : ''
  }, [_c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "nav nav-slides",
    class: _vm.small ? 'smallNav' : ''
  }, [_c('button', {
    staticClass: "nav-btn arrow arrow-left",
    on: {
      "click": _vm.prev
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('span', {
    class: !_vm.small ? 'number-buttons' : ''
  }, [_vm._l((_vm.slides), function(n) {
    return [_c('button', {
      staticClass: "nav-btn slide-btn",
      class: _vm.active === n - 1 ? 'active-btn' : '',
      on: {
        "click": function($event) {
          return _vm.setActive(n - 1)
        }
      }
    }, [_vm._v("0" + _vm._s(n) + "\n        ")])]
  })], 2), _vm._v(" "), _c('button', {
    staticClass: "nav-btn arrow arrow-right",
    on: {
      "click": _vm.next
    }
  }, [_vm._v(">\n      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "container slides"
  }, [_c('div', [_c('div', [_vm._t("item")], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cc52b23!./~/vue-loader/lib/selector.js?type=template&index=0!./src/SlideShow.vue
// module id = 140
// module chunks = 0